export const MIN_CAMERA_ANGLE = 0;
export const MAX_CAMERA_ANGLE = 70;
export const DEFAULT_FIXED_CAMERA_ANGLE = 55;

/** Pitch in degrees from a directly overhead view. */
export function isCameraAngle(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value)
    && value >= MIN_CAMERA_ANGLE && value <= MAX_CAMERA_ANGLE;
}

export function readCameraAngle(value: string | null): number | undefined {
  if (value === null || value.trim() === '') return undefined;
  const angle = Number(value);
  return isCameraAngle(angle) ? angle : undefined;
}
